module.exports = __webpack_public_path__ + "static/media/menu-marketing-inactive.6a2937a9.svg";